import { Flex } from "antd";
import NxMarkdown from "../../shared/NxMarkdown";

const Minutes = ({ minutes }: { minutes?: string }) => {
  if (!minutes?.trim()) return null;

  return (
    <Flex vertical>
      <NxMarkdown text={minutes} />
    </Flex>
  );
};

export default Minutes;
